import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepByStepLoanSliderInput, withExperiment } from 'embed/experiments'

import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
  selectedVariantId?: string
}

export const StepbystepApplicationStepAnnualIncome: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>What’s your annual income?</StepTitle>
    <ApplicationField
      onEnter={props.onEnter}
      product={Product.Loan}
      field={
        props.selectedVariantId === StepByStepLoanSliderInput.variants.SliderInput.id
          ? Fields.AnnualIncomeLoanSlider
          : Fields.AnnualIncomeLoan
      }
    />
  </Wrapper>
)

export default withExperiment(StepByStepLoanSliderInput)(StepbystepApplicationStepAnnualIncome)
